import { Component, computed, Inject, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

/**
 * Basic custom datepicker for use on set and delivery pages
 */
@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.css'],
    standalone: false
})
export class DateTimePickerComponent {

  formFields: FormGroup = new FormGroup({
    day: new FormControl('', Validators.max(31)),
    month: new FormControl('', Validators.max(12)),
    year: new FormControl('', Validators.max(new Date().getFullYear() + 1)),
  });

  @ViewChild(MatCalendar) calendar!: MatCalendar<Date>;

  selectedDate: Date;
  selectedTime: { hour: number, minute: number };
  maxDate: Date = new Date();

  constructor(
    public dialogRef: MatDialogRef<DateTimePickerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { 
      date: Date, 
      minDate: Date, 
      isDelivery: boolean, 
      isHMS: boolean, 
      isStart: boolean, 
      isEnd: boolean, 
      isUnloading: boolean,
      isTrawl: boolean,
      hmsField: string
    },
    private toastr: ToastrService
  ) {
    this.selectedTime = { hour: data.date.getHours(), minute: data.date.getMinutes() };
    this.selectedDate = data.date;

    this.formFields.patchValue({
      day: this.selectedDate.getDate(),
      month: this.selectedDate.getMonth() + 1,
      year: this.selectedDate.getFullYear(),
    });

    this.formFields.valueChanges.subscribe((values) => {
      if (this.formFields.valid) {
        this.selectedDate.setDate(parseInt(values.day));
        this.selectedDate.setMonth(parseInt(values.month) - 1);
        this.selectedDate.setFullYear(parseInt(values.year));
        this.calendar.updateTodaysDate();
      }
    });
  }

  onCalendarDateSelected(newDate: Date): void {
    this.selectedDate = newDate;
    this.formFields.patchValue({
      day: this.selectedDate.getDate(),
      month: this.selectedDate.getMonth() + 1,
      year: this.selectedDate.getFullYear(),
    }, { emitEvent: false });
  }

  onConfirm() {
    if (this.formFields.invalid) {
      this.toastr.error('Please enter a valid date', 'Error');  
      return;
    }
    this.selectedDate.setHours(this.selectedTime.hour);
    this.selectedDate.setMinutes(this.selectedTime.minute);
    if ((!this.data.isDelivery && !this.data.isUnloading) && this.selectedDate > new Date()) {
      this.toastr.warning('Future date-time not permitted', 'Warning');
    } else {
      this.dialogRef.close(this.selectedDate);
    }
  }

  handleKeyUp(key: any) {
    if (key.keyCode === 13) this.onConfirm();
  }

   _forbidNonNumeric(control: AbstractControl) {
        control.setValue(control.value.replace(/[^0-9]/g, ''), {onlySelf: true, emitEvent: false});   
    }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
